import { useEffect, useState } from 'react';
import { AiOutlineTrophy } from 'react-icons/ai';
import { FiChevronDown } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { filter } from 'draft-js/lib/DefaultDraftBlockRenderMap';

export default function SchoolTable({ data = [], filters, sortConfig, onSort, selectedGre, setSelectedSchool, setSelectedGre, kpis: detailKpis, getColor }) {
  const [filteredData, setFilteredData] = useState(data.institutions);

  const kpis = [
    {
      id: 1,
      title: 'Matemática e suas Tecnologias',
      value: data?.kpis?.matematica || 0,
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 2,
      title: 'Ciências Humanas e Sociais Aplicadas',
      value: data?.kpis?.ciencias_humanas || 0,
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 3,
      title: 'Ciências da Natureza',
      value: data?.kpis?.ciencias_natureza || 0,
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 4,
      title: 'Linguagens e suas Tecnologias',
      value: data?.kpis?.linguagens || 0,
      variation: 'report-kpi-card--analytics'
    }
  ];

  useEffect(() => {
    if (filters.values.searchTerm.length > 0) {
      const filtered = data?.institutions?.filter(item => item?.['institution_name']?.toLowerCase().includes(filters.values.searchTerm.toLowerCase()));
      setFilteredData(filtered);
    } else {
      setFilteredData(data?.institutions);
    }
  }, [filters.values['searchTerm']]);

  return (
    <div className="round-dg-wrapper">
      <div className="mb-6 flex gap-2 border-b border-neutral-lightest pb-3">
        <span className="text-neutral-light">GREs</span>
        <span
          onClick={() => {
            setSelectedGre(null);
            setSelectedSchool(null);
          }}
          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
        >
          <FiChevronDown
            style={{ transform: 'rotate(90deg)' }}
            className="card__icon"
          />
        </span>
        <span className="font-semibold text-primary-dark">{selectedGre?.['regional_name']}</span>
      </div>
      <div className="rounded-2xl bg-neutral-bright p-4">
        <div className="report-kpi-card-wrapper mb-6">
          {kpis.map(kpi => (
            <div
              className={`report-kpi-card ${kpi.variation}`}
              key={kpi.id}
            >
              <h3 className="report-kpi-card__title font-semibold text-primary-dark">{kpi.title}</h3>
              <p
                className="report-kpi-card__value"
                title={kpi.value}
              >
                {kpi.value ? `${kpi.value.toFixed(2)}%` : '--'}
              </p>
            </div>
          ))}
        </div>

        <div className="report-widget__filter mb-2">
          <input
            className="report-form__control report-form__control--md"
            aria-label="Pesquisar"
            placeholder="Pesquisar"
            type="search"
            name="search"
            id="search"
            onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
            disabled={data?.length === 0 && filters.searchTerm === ''}
          />
        </div>

        <div className="round-dg-wrapper">
          {filteredData?.length === 0 ? (
            <EmptyState
              title="Nenhum dado disponível"
              type="data"
              text="Não há dados a serem exibidos."
              className="my-10"
            />
          ) : (
            <table
              className="round-dg round-dg--light"
              style={{ minWidth: '564px' }}
            >
              <thead className="round-dg__header">
                <tr className="round-dg__row">
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '80px' }}
                  >
                    Posição
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '50px' }}
                  ></th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-52">Unidade Escolar</th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '200px' }}
                  >
                    Matemática
                    <span
                      onClick={() => onSort('math')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'math' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '200px' }}
                  >
                    Ciências Humanas
                    <span
                      onClick={() => onSort('humanities')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'humanities' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '200px' }}
                  >
                    Ciências da Natureza
                    <span
                      onClick={() => onSort('natural-sciences')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'natural-sciences' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-[160px]">
                    <div className="flex w-full items-center">
                      <span
                        className="flex-1 truncate text-left"
                        title="Linguagens e suas Tecnologias"
                      >
                        Linguagens e suas Tecnologias
                      </span>
                      <span
                        onClick={() => onSort('technology')}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1 shrink-0"
                      >
                        <FiChevronDown
                          style={{ transform: sortConfig.field === 'technology' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </div>
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '80px' }}
                  ></th>
                </tr>
              </thead>

              <tbody className="round-dg__body">
                {filteredData?.map((item, i) => (
                  <tr
                    key={item.id}
                    className={`round-dg__row`}
                  >
                    <td className="round-dg__cell round-dg__cell--sm u-text-right">{i + 1 < 10 ? `0${i + 1}` : i + 1}</td>
                    <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                      {i === 0 && <AiOutlineTrophy className="card__icon card__icon--golden mr-3" />}
                      {i === 1 && <AiOutlineTrophy className="card__icon card__icon--silver mr-3" />}
                      {i === 2 && <AiOutlineTrophy className="card__icon card__icon--bronze mr-3" />}
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row font-semibold text-primary-dark">{item?.['institution_name']}</th>
                    <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.matematica)}`}>{item?.matematica !== null ? `${item?.matematica.toFixed(2)}%` : '--'}</td>
                    <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_humanas'])}`}>{item?.['ciencias_humanas'] !== null ? `${item?.['ciencias_humanas'].toFixed(2)}%` : '--'}</td>
                    <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_natureza'])}`}>{item?.['ciencias_natureza'] !== null ? `${item?.['ciencias_natureza'].toFixed(2)}%` : '--'}</td>
                    <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['linguagens'])}`}>{item?.['linguagens'] !== null ? `${item?.['linguagens'].toFixed(2)}%` : '--'}</td>
                    <td className="round-dg__cell round-dg__cell--sm">
                      <span
                        onClick={() => {
                          setSelectedSchool(item);
                        }}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-2"
                      >
                        <FiChevronDown
                          style={{ transform: 'rotate(270deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
